var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"min-height":"600px"}},[_c('iframe',{staticClass:"border-0 w-100 top-0 h-100 position-absolute img-margin",staticStyle:{"max-height":"500px","max-width":"90%"},attrs:{"src":"https://player.vimeo.com/video/544483447?color=44619b&title=0&byline=0&portrait=0&badge=0&speed=1"}})])
}]

export { render, staticRenderFns }